import React from "react";
import { motion } from "framer-motion";
import { FileQuestion } from "lucide-react";

export default function EmptyState() {
	return (
		<div className="aeo-grader-report">
			<div className="empty-state">
				<motion.div
					className="empty-state__panel"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
				>
					<div className="empty-state__icon-wrap">
						<FileQuestion className="empty-state__icon" />
					</div>
					<h2 className="empty-state__title">No Report Data</h2>
					<p className="empty-state__message">
						This audit doesn&apos;t have any report data yet. Please wait for the audit to
						complete.
					</p>
				</motion.div>
			</div>
		</div>
	);
}
